/* eslint-disable no-unused-vars */
import Headroom from "../vendor/headroom";
import { changeCountry, updateGlobalECountry } from "../shop/connect";
import { stokpress } from "../util/helper";
import { handleCountryChange as updatePfasCountry } from "./pfas";
var stellarHeadroom = {};
var $headroomSlider = $(".js-headroom-flickity");
(function ($) {
  stellarHeadroom.init = function () {
    var msg = document.getElementById("js-main-nav-msg");
    var nav = document.getElementById("js-nav-menu");
    var checkoutTimeline = $("#js-checkout-steps");
    var geomodal = document.getElementById("geoModal");
    var navbar = $(".navbar");
    var msgHeight = "-" + $("#js-nav-menu").outerHeight(true) + "px";
    stellarHeadroom.usp();
    if (msg && nav) {
      var headroom = new Headroom(nav, {
        offset: msg.offsetHeight,
        classes: {
          notTop: "is-fixed-top"
        },
        onTop: function onTop() {
          msg.classList.remove("d-none");
          navbar.removeClass("hidden-headroom");
          stellarHeadroom.usp();
          setTimeout(function () {
            $("body").autoPadding({
              source: $(".js-header")
            });
          }, 300);
        },
        onNotTop: function onNotTop() {
          msg.classList.add("d-none");
          navbar.addClass("hidden-headroom");
          if ($(".js-fine-print").length > 0 && $(".js-headroom-text").length > 1) {
            $headroomSlider.flickity("destroy");
          }
        },
        onPin: function onPin() {
          if (matchMedia("screen and (max-width: 991px)").matches && $("body").hasClass("page-loaded")) {
            nav.style.transform = "translateY(0)";
          }
        },
        onUnpin: function onUnpin() {
          if (matchMedia("screen and (max-width: 991px)").matches && $("body").hasClass("page-loaded")) {
            nav.style.transform = "translateY(" + msgHeight + ")";
          }
        }
      });
      headroom.init();
    }
    stellarHeadroom.showDrop();
    stellarHeadroom.changeShippingCountry();
  };
  stellarHeadroom.changeShippingCountry = function () {
    var shipToContainer = document.getElementsByClassName("js-shipping-country");
    if (!shipToContainer.length) return;
    var isGECheckout = document.getElementById("global-e-checkout");
    Array.prototype.forEach.call(shipToContainer, function (el) {
      if (isGECheckout) {
        var shippingContainer = el.parentNode;
        shippingContainer.classList.add("d-none");
        if (shippingContainer.classList.contains("d-lg-block")) {
          shippingContainer.classList.remove("d-lg-block");
        }
      }
      var items = el.getElementsByClassName("js-country-item");
      var state = el.querySelector(".js-shipping-state");
      if (items) {
        for (var index = 0; index < items.length; index++) {
          var element = items[index];
          element.addEventListener("click", function (e) {
            var _this = this;
            e.preventDefault();

            // remove class to all active items
            var activeCountries = $(".js-shipping-country .nav-item.is-active");
            if (activeCountries.length) {
              activeCountries.removeClass("is-active");
            }
            var activeParentNode = this.parentNode;
            if (activeParentNode.classList) {
              activeParentNode.classList.add("is-active");
            } else {
              activeParentNode.className += " is-active";
            }
            var selectedCountry = this.innerText;
            var parent = stokpress.findAncestor(this, "js-shipping");
            if (parent && parent.querySelector(".js-selectedCountry-text")) {
              parent.querySelector(".js-selectedCountry-text").innerText = selectedCountry;
            }
            changeCountry(this.dataset.code).then(function () {
              console.log("REDIRECT CONTRY CHANGE");
              updatePfasCountry(_this.dataset.code);
            });

            // Old code for country change
            //window.Checkout.countryChangeProcess(this.dataset.code, state.value, true);
          });
        }
      }
    });
  };
  stellarHeadroom.showDrop = function () {
    // let elParent = document.getElementsByClassName('js-shipping')[0];
    // let elChild = document.getElementsByClassName('js-headroom-dropdown')[0];
    // elChild.style.minWidth = elParent.offsetWidth + 'px';

    var dropdownStatus = false;
    var modal = document.getElementsByClassName("js-headroom-dropdown")[0];
    if (!modal) return;
    if (!$(".headroom-wrapper")) return;
    $(".js-headroom-dropdown").click(function (event) {
      if (!dropdownStatus) {
        $(".headroom-wrapper").addClass("showDropdown");
        $(".js-headroom-dropdown").addClass("showDropdown");
        dropdownStatus = true;
      } else {
        $(".headroom-wrapper").removeClass("showDropdown");
        $(".js-headroom-dropdown").removeClass("showDropdown");
        dropdownStatus = false;
      }
      event.stopPropagation();
    });

    // When the user clicks anywhere outside of the modal, close it

    window.onclick = function (event) {
      if (dropdownStatus) {
        if (event.target != modal) {
          $(".headroom-wrapper").removeClass("showDropdown");
          $(".js-headroom-dropdown").removeClass("showDropdown");
          dropdownStatus = false;
        }
      }
    };
  };
  stellarHeadroom.usp = function () {
    if ($(".js-fine-print").length > 0 && $(".js-headroom-text").length > 1) {
      $headroomSlider.on("ready.flickity", function () {
        $headroomSlider.removeClass("invisible");
      });
      var options = {
        cellAlign: "left",
        groupCells: true,
        wrapAround: true,
        prevNextButtons: false,
        pageDots: false,
        autoPlay: 4000,
        pauseAutoPlayOnHover: true,
        dragThreshold: 3,
        selectedAttraction: 0.01,
        friction: 0.15,
        freeScrollFriction: 0.02
      };
      $headroomSlider.flickity(options);
    } else {
      $headroomSlider.removeClass("invisible");
    }
  };
  stellarHeadroom.init();
})(jQuery);
window.stellarHeadroom = stellarHeadroom;


// WEBPACK FOOTER //
// ./scripts/components/headroom.js